module.exports = __webpack_public_path__ + "img/rima-rifai-avatar.8e9fcc22.jpg";